var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.iconOptions.icon,{tag:"component",attrs:{"width":_vm.iconOptions.width,"height":_vm.iconOptions.height,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }